var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_2336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99998 12.6667C3.99998 13.4 4.59998 14 5.33331 14H10.6666C11.4 14 12 13.4 12 12.6667V6C12 5.26667 11.4 4.66667 10.6666 4.66667H5.33331C4.59998 4.66667 3.99998 5.26667 3.99998 6V12.6667ZM5.99998 6H9.99998C10.3666 6 10.6666 6.3 10.6666 6.66667V12C10.6666 12.3667 10.3666 12.6667 9.99998 12.6667H5.99998C5.63331 12.6667 5.33331 12.3667 5.33331 12V6.66667C5.33331 6.3 5.63331 6 5.99998 6ZM10.3333 2.66667L9.85998 2.19333C9.73998 2.07333 9.56665 2 9.39331 2H6.60665C6.43331 2 6.25998 2.07333 6.13998 2.19333L5.66665 2.66667H3.99998C3.63331 2.66667 3.33331 2.96667 3.33331 3.33333C3.33331 3.7 3.63331 4 3.99998 4H12C12.3666 4 12.6666 3.7 12.6666 3.33333C12.6666 2.96667 12.3666 2.66667 12 2.66667H10.3333Z",
    fill: "#F94850"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_2336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.300fa7034dc363581f9fc4b20a3e95ae.svg";
export { ForwardRef as ReactComponent };